import { render, staticRenderFns } from "./SecretaryCall.vue?vue&type=template&id=7a92eb6f&scoped=true&"
import script from "./SecretaryCall.vue?vue&type=script&lang=js&"
export * from "./SecretaryCall.vue?vue&type=script&lang=js&"
import style0 from "./SecretaryCall.vue?vue&type=style&index=0&id=7a92eb6f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a92eb6f",
  null
  
)

export default component.exports